import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// twMerge résout les conflits d'utilitaires Tailwind (px-2 vs px-4) que clsx
// laisserait tous les deux dans la chaîne, le dernier du CSS gagnant au hasard.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
